import { render, staticRenderFns } from "./MyStore.vue?vue&type=template&id=27dce005"
import script from "./MyStore.vue?vue&type=script&lang=js"
export * from "./MyStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports